/* eslint-disable no-console */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable indent */
import axios from 'axios';
import { mainUrl } from '../../Constants';
import { tokenInvalid } from './LoginActions';
export const formatDateYYYYMMDD = (date) => {
	let today = new Date(date);
	let dd = today.getDate();
	let mm = today.getMonth() + 1; //January is 0!

	let yyyy = today.getFullYear();
	if (dd < 10) {
		dd = '0' + dd;
	}
	if (mm < 10) {
		mm = '0' + mm;
	}
	return mm + '/' + dd + '/' + yyyy;
};

export const clearErrs = (e) => {
	const type = e.toUpperCase() + "_CLEAR_ERRS";
	return { type };
};
export const clearSuccess = (e) => {
	const type = e.toUpperCase() + "_CLEAR_SUCCESS";
	return { type };
};
export const clearSecondarySuccess = (e) => {
	const type = e.toUpperCase() + "_CLEAR_SECONDARY_SUCCESS";
	return { type };
};
export const clearTertiarySuccess = (e) => {
	const type = e.toUpperCase() + "_CLEAR_TERTIARY_SUCCESS";
	return { type };
};
export const getAll = (type, data) => {
	if (type === "onlyActiveUsers") {
		const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/users?activeOnly=true`;
		type = "users";
		return restFire(url, data, 'get', type);
	}
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/${type}`;
	return restFire(url, data, 'get', type);
};


export const add = (type, data) => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/${type}`;
    return restFire(url, data, 'post', type);
};

export const edit = (type, data, id) => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/${type}/${id}`;
	return restFire(url, data, 'put', type);
};


export const del = (type, data, id) => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/${type}/${id}`;
	return restFire(url, data, 'delete', type);
};

export const getOne = (type, data, id) => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/${type}/${id}`;
	return restFire(url, data, 'get', type);
};


export const getRooms = () => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/rooms`;
	return restFire(url, null, 'get', 'rooms');
};


export const getAllRooms = () => {
const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/rooms/all`;
	return restFire(url, null, 'get', 'rooms');
};


export const getScheduledEvents = (date) => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/scheduledEvents?forDate=${formatDateYYYYMMDD(date)}&offset=${new Date().getTimezoneOffset()}`;
	return restFire(url, null, 'get', 'events');
};

export const addBuilding = (data) => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/buildings`;
	return restFire(url, data, 'post', 'buildings');
};

export const addFloor = (data) => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/buildings/${data.buildingId}/floors`;
	return restFire(url, data, 'post', 'floors');
};

export const getRoles = () => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/users/roles`;
	return restFire(url, null, 'get', 'roles');
};

export const getUserGroups = () => {
	const url = `${mainUrl}accounts/${localStorage.getItem('accountId')}/usergroups`;
	return restFire(url, null, 'get', 'userGroups');
};



// Api endpoints are different for account data
// Therefore, create custom actions for all account management
export const getSingleAccount = (type, data, id) => {
	const url = `${mainUrl}accounts/${id}`;
	return restFire(url, data, 'get', type);
};

export const getAccounts = (data) => {
	const url = `${mainUrl}accounts`;
	return restFire(url, data, 'get', 'accounts');
};

export const addNewAccount = (data) => {
	const url = `${mainUrl}accounts`;
	return restFire(url, data, 'post', 'accounts');
};

export const editAccount = (type, data, id) => {
	const url = `${mainUrl}accounts/${id}`;
	return restFire(url, data, 'put', type);
};

export const delAccount = (type, data, id) => {
	const url = `${mainUrl}accounts/${id}`;
	return restFire(url, data, 'delete', type);
};


const returnDispatchItem = (type, action, value) => {
	const upperCaseType = type.toUpperCase();
	let actionType = '';
	if (action === 'LOADING') actionType = 'isLoading';
	if (action === 'ERROR') actionType = 'hasError';
	if (action === 'ERR_MSG') actionType = 'errMsg';
	if (action === 'REDIRECT') actionType = 'redirect';
	if (action === 'FETCH_SUCCESS') actionType = 'data';
	if (action === 'SUCCESS') actionType = 'success';
	if (action === 'SUCCESS_MESSAGE') actionType = 'successMsg';
	if (action === 'CLEAR_SUCCESS') actionType = 'success';
	const dispatchObj = {
		type: `${upperCaseType}_${action}`,
	};
	dispatchObj[actionType] = value;
	return dispatchObj;
};

const restFire = (url, data, method, type) => {
	axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('id_token')}`;
	return (dispatch) => {
		dispatch(returnDispatchItem(type, 'LOADING', true));
		if (data) {

			if (Object.keys(data).length > 0) {
				data = Object.assign({}, { ...data, accountId: localStorage.getItem('accountId') });
			}
		}
		axios.request({
			url,
			data,
			method,
			headers: {
				Authorization: `Bearer ${localStorage.getItem('id_token')}`,
				'Content-Type': 'application/json',
			},
		})
			.then((response) => {
				type = type.toUpperCase();
				// TODO: clean up based on methods
				if (response.status !== 200 && method !== 'delete' && method !== 'put' && method !== 'post') {
					dispatch(returnDispatchItem(type, 'ERROR', true));
					dispatch(returnDispatchItem(type, 'ERR_MSG', response.status));
					throw Error(response.status);
				}
				dispatch(returnDispatchItem(type, 'LOADING', false));
				return response;
			})
			.then((items) => {
				if (method === 'get') {
					dispatch(returnDispatchItem(type, 'FETCH_SUCCESS', items.data));
					dispatch(returnDispatchItem(type, 'FETCHALL_SUCCESS', items.data));
					// clear redirects on get
					dispatch(returnDispatchItem(type, 'REDIRECT', false));
					dispatch(returnDispatchItem(type, 'ERROR', false));
					dispatch(returnDispatchItem(type, 'ERR_MSG', ""));
				}
				// fetch again on edit or delete
				if (method === 'delete' || method === 'put' || method === 'post') {
					dispatch(returnDispatchItem(type, 'SUCCESS', true));
					dispatch(returnDispatchItem(type, 'SUCCESS_MESSAGE', method));
					dispatch(returnDispatchItem(type, 'REDIRECT', true));
					                    
					// special call in case of accounts type - special because the URL to API is not like other types
					if(type.toUpperCase() ==='ACCOUNTS')
				     	dispatch(getAccounts(type));
					else
					dispatch(getAll(type));
				}
			})
			.catch((e) => {
				if (!e.response) {
					alert(e);
					return false;
				}
				if (e.response.status === 401) {
					dispatch(tokenInvalid());
				}
				let errList = "";
				if (typeof (e.response.data) === 'string') {
					if (e.response.data.startsWith('Building')) {
						errList = "Please select a Building";
					}
					if (e.response.data.startsWith('Floor')) {
						errList = "Please select a Floor";
					}
					if (e.response.data.startsWith('RoomType')) {
						errList = "Please select a Room Type";
					}
					// work around for response data as string and status as 400
					if (e.response.status == 400) {
						alert(e.response.data);
						return false;
					}
				} else {
					if (e.response.status == 400) {
						Object.keys(e.response.data).forEach(r => {
							// building add errors
							if (r === 'open') {
								e.response.data.open = "Open Time is required.";
							}
							if (r === 'closed') {
								e.response.data.closed = "Closed Time is required.";
							}
							//resource add errors
							if (r === 'assetTypeId') {
								e.response.data.assetTypeId = "Resource Type is required.";
							}
							//users add errors
							if (r === 'userGroupId') {
								e.response.data.userGroupId = "User Group is required.";
							}
							//floor add errors
							if (r === 'buildingId') {
								e.response.data.buildingId = "Building is required.";
							}
							errList += e.response.data[r] + "\n";
						});
					} else {
						errList += e.response.status + "\n";
					}
				}
				dispatch(returnDispatchItem(type, 'ERROR', true));
				dispatch(returnDispatchItem(type, 'ERR_MSG', errList));
			});
	};
};



// WEBPACK FOOTER //
// ./src/Store/Actions/RestActions.js